import { matchPath } from 'react-router-dom'
import {
  APPLICATION_DETAIL_VIEW_PARAM,
  APPLICATION_DETAIL_MANAGER_VIEW,
  ROUTES,
} from '../config/constants'

export { APPLICATION_DETAIL_VIEW_PARAM, APPLICATION_DETAIL_MANAGER_VIEW } from '../config/constants'


/** Заявки с расчётов (VED applications). Раздел в SPA calculator, не frontend/company. */
export const applicationsListPath = () =>
  `/${ROUTES.CABINET}/${ROUTES.APPLICATIONS}`

export { companyOrdersListPath, companyOrderDetailPath } from './companyAppUrl'

export const calculationPath = (calculationNumber: string) =>
  `/${ROUTES.CABINET}/${ROUTES.CALCULATOR}/${calculationNumber}`

export const applicationManagerDetailPathPattern =
  `/${ROUTES.CABINET}/${ROUTES.APPLICATIONS}/${ROUTES.APPLICATIONS_MANAGER}/:publicId`

export const applicationClientDetailPathPattern =
  `/${ROUTES.CABINET}/${ROUTES.APPLICATIONS}/:publicId`

export function isApplicationManagerDetailPath(pathname: string): boolean {
  return Boolean(matchPath({ path: applicationManagerDetailPathPattern, end: true }, pathname))
}

export const applicationDetailPath = ({ publicId, managerView = false }: ApplicationDetailPathArgs) => {
  const base = `/${ROUTES.CABINET}/${ROUTES.APPLICATIONS}`
  if (managerView) {
    return `${base}/${ROUTES.APPLICATIONS_MANAGER}/${publicId}`
  }
  return `${base}/${publicId}`
}

export const applicationDetailNavigateOptions = (managerView: boolean) => ({
  state: { applicationsManagerView: managerView } satisfies ApplicationDetailLocationState,
})

export function resolveApplicationManagerView({
  canManageApplications,
  searchParams,
  locationState,
  pathname,
}: ApplicationResolveApplicationManagerViewArgs): boolean {
  if (!canManageApplications) {
    return false
  }
  if (pathname && isApplicationManagerDetailPath(pathname)) {
    return true
  }
  if (searchParams.get(APPLICATION_DETAIL_VIEW_PARAM) === APPLICATION_DETAIL_MANAGER_VIEW) {
    return true
  }
  return locationState?.applicationsManagerView === true
}

/** @deprecated Use /applications/manager/:publicId; retained for legacy ?view=manager redirects. */
export function applicationDetailManagerViewSearchParams({ managerView, current }: ApplicationDetailManagerViewSearchParamsArgs
): URLSearchParams {
  const next = new URLSearchParams(current ?? undefined)
  if (managerView) {
    next.set(APPLICATION_DETAIL_VIEW_PARAM, APPLICATION_DETAIL_MANAGER_VIEW)
  } else {
    next.delete(APPLICATION_DETAIL_VIEW_PARAM)
  }
  return next
}
